
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portfolio/port",
      function () {
        return require("private-next-pages/portfolio/port.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portfolio/port"])
      });
    }
  